// import debug from 'debug';
// import {XKnex} from "../sql-data-mapper";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return SqlMgrv2;
    }
});
const _SqlClientFactory = /*#__PURE__*/ _interop_require_default(require("~/db/sql-client/lib/SqlClientFactory"));
const _KnexMigratorv2 = /*#__PURE__*/ _interop_require_default(require("~/db/sql-migrator/lib/KnexMigratorv2"));
const _Debug = /*#__PURE__*/ _interop_require_default(require("~/db/util/Debug"));
const _NcConnectionMgrv2 = /*#__PURE__*/ _interop_require_default(require("~/utils/common/NcConnectionMgrv2"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const log = new _Debug.default('SqlMgr');
let SqlMgrv2 = class SqlMgrv2 {
    async migrator(_base) {
        return this._migrator;
    }
    static async testConnection(args = {}) {
        const client = await _SqlClientFactory.default.create(args);
        const result = await client.testConnection();
        // close connection
        await client.knex.destroy();
        return result;
    }
    /**
   *
   *
   * @param {*} args
   * @param {String} args.env
   * @param {dbAlias} args.dbAlias
   * @param {String} op - sqlClient function to call
   * @param {*} opArgs - sqlClient function arguments
   * @memberof SqlMgr
   */ async sqlOp(source, op, opArgs) {
        const func = this.sqlOp.name;
        log.api(`${func}:args:`, source, op, opArgs);
        // create sql client for this operation
        const client = await this.getSqlClient(source);
        // do sql operation
        const data = await client[op](opArgs);
        return data;
    }
    /**
   *
   *
   * @param {*} base
   * @param {String} base.env
   * @param {dbAlias} base.dbAlias
   * @param {String} op - sqlClient function to call
   * @param {*} opArgs - sqlClient function arguments
   * @memberof SqlMgr
   */ async sqlOpPlus(source, op, opArgs) {
        var _source_getConfig;
        const func = this.sqlOpPlus.name;
        log.api(`${func}:args:`, source, op, opArgs);
        if ((_source_getConfig = source.getConfig()) == null ? void 0 : _source_getConfig.schema) {
            opArgs = _extends({}, opArgs, {
                schema: source.getConfig().schema
            });
        }
        // create sql client for this operation
        const sqlClient = await this.getSqlClient(source); //await this.baseGetSqlClient(args);
        // do sql operation
        const sqlMigrationStatements = await sqlClient[op](opArgs);
        /* // create sql migration files
    const sqlMigrationFiles = await this.sql-migrator(base).migrationsCreate(base);
    console.log(`Sql Migration Files for '${op}'`, sqlMigrationFiles);

    // write sql statements to migration files
    console.log(
      `Write sql migration files for '${op}' with`,
      sqlMigrationStatements
    );
    await this.sql-migrator(base).migrationsWrite({
      base,
      ...sqlMigrationStatements.data.object,
      folder: this.currentProjectFolder,
      up: sqlMigrationFiles.up,
      down: sqlMigrationFiles.down
    });

    // mark as migration done in nc_evolutions table
    console.log(
      `TODO: write sql migration files for '${op}' with`,
      sqlMigrationStatements
    );
    const migrationArgs = {
      base: base,
      sqlContentMigrate: 0,
      migrationSteps: 9999,
      folder: this.currentProjectFolder,
      sqlClient
    };
    await this.sql-migrator(base).migrationsUp(migrationArgs);
*/ return sqlMigrationStatements;
    }
    async getSqlClient(source) {
        if (source.is_meta && this.ncMeta) {
            return _NcConnectionMgrv2.default.getSqlClient(source, this.ncMeta.knex);
        }
        return _NcConnectionMgrv2.default.getSqlClient(source);
    }
    /**
   * Creates an instance of SqlMgr.
   * @param {*} args
   * @param {String} args.toolDbPath - path to sqlite file that sql mgr will use
   * @memberof SqlMgr
   */ constructor(context, args, ncMeta = null){
        const func = 'constructor';
        log.api(`${func}:args:`, args);
        // this.metaDb = args.metaDb;
        this._migrator = new _KnexMigratorv2.default(context, args);
        this.ncMeta = ncMeta;
        this.context = context;
    }
};
